import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class BillingCard extends BaseModel {
  /**
   * @var {string}
   */
  brand;

  /**
   * @var {number}
   */
  expiryMonth;

  /**
   * @var {number}
   */
  expiryYear;

  /**
   * @var {?string}
   */
  firstName;

  /**
   * @var {string}
   */
  fundingType;

  /**
   * @var {string}
   */
  iin;

  /**
   * @var {string}
   */
  last4;

  /**
   * @var {?string}
   */
  lastName;

  /**
   * @var {string}
   */
  maskedNumber;

  /**
   * @var {string}
   */
  object;

  constructor(model = {}) {
    super();

    this.brand = model.brand;
    this.expiryMonth = model.expiryMonth;
    this.expiryYear = model.expiryYear;
    this.firstName = model.firstName;
    this.fundingType = model.fundingType;
    this.iin = model.iin;
    this.last4 = model.last4;
    this.lastName = model.lastName;
    this.maskedNumber = model.maskedNumber;
    this.object = model.object;
  }
}
